<script setup>
import { inputRules } from "@/utils/input_rules";
import LabelledField from "@/components/inputs/LabelledField";
import LoadingArea from "@/components/Utils/LoadingArea.vue";
import { useRouter } from "@/components/Utils/functions";

const router = useRouter();

const props = defineProps({
  fetchingData: {
    type: Boolean,
    default: false,
  },
  performingCrud: {
    type: Boolean,
    default: false,
  },
  model: {
    type: Object,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: ""
  }
});
</script>

<template>
  <v-card outlined class="pb-10">
    <v-card-title class="px-md-7 tableHeader text--text justify-space-between">
      <span>{{ title }}</span>
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            class=""
            :style="{ color: 'inherit' }"
            v-on="on"
            v-bind="attrs"
            @click="router.back()"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </template>
        Close
      </v-tooltip>
    </v-card-title>
    <v-card-text class="mt-6">
      <v-container>
        <v-row v-if="fetchingData">
          <v-col cols="12" md="4">
            <v-skeleton-loader type="button" class="skeleton-fill-width" />
          </v-col>
        </v-row>
        <LoadingArea v-else :loading="performingCrud">
          <v-row>
            <v-col cols="12" md="4">
              <LabelledField :label="$t('permissionNameMsg')" required>
                <v-text-field
                  class="text_field background"
                  outlined
                  dense
                  :rules="inputRules.required"
                  v-model="props.model.name"
                  :readonly="readonly"
                  :disabled="readonly"
                ></v-text-field>
              </LabelledField>
            </v-col>
          </v-row>
        </LoadingArea>
      </v-container>
    </v-card-text>
    <v-card-actions class="pr-md-7">
      <v-spacer />
      <v-btn
        depressed
        class="primary text-none mt-3"
        type="submit"
        :loading="performingCrud"
        :disabled="fetchingData || performingCrud"
      >
        {{ $t("saveMsg") }}
        <v-icon right> mdi-content-save </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
